import { render, staticRenderFns } from "./CollectionsListRow.vue?vue&type=template&id=0dbc6f98"
import script from "./CollectionsListRow.vue?vue&type=script&lang=js"
export * from "./CollectionsListRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports